module.exports = __webpack_public_path__ + "static/media/even.b770c0ea.png";